import { useLayoutEffect, useEffect } from 'react';

function createPortalNode(props) {
  const node = document.createElement("div");
  node.setAttribute("data-portal", "true");
  if (typeof props.className === "string") {
    node.classList.add(...props.className.split(" ").filter(Boolean));
  }
  if (typeof props.style === "object") {
    Object.assign(node.style, props.style);
  }
  if (typeof props.id === "string") {
    node.setAttribute("id", props.id);
  }
  return node;
}
const useIsomorphicEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;

export { createPortalNode, useIsomorphicEffect };
